module.exports = __webpack_public_path__ + "static/live-room-360-838b57051b46674a9d2330acf2e0b1fb.jpg";